function ProgressBar({ progress = 0, showProgress = true, m }) {

    const width = `${progress}%`;
    const style = progress === 100 ? `h-full rounded-full bg-[#b8337a] transition-all duration-500 ease-in-out` : 
    `
        h-full rounded-full
        bg-[linear-gradient(135deg,#b8337a_25%,#d168a6_25%,#d168a6_50%,#b8337a_50%,#b8337a_75%,#d168a6_75%,#d168a6_100%)]
        bg-[length:40px_40px]
        animate-[moveStripe_1s_linear_infinite]
        transition-all duration-500 ease-in-out
    `
    return (
        <div className={`flex items-center gap-2 ${m}`}>
            <div className="w-full h-4 bg-gray-200/50 rounded-full overflow-hidden">
                <div
                    style={{ width }}
                    className={style}
                />
            </div>
            {showProgress && <span className="text-black font-semibold">{width}</span>}
        </div>
    );
}

export default ProgressBar;